import { C, STROKE, Figure, Label, Leader, arrow } from './figureStyle';

const ID = 'fig-radiatornoegle';

export default function RadiatornoegleFigure() {
  return (
    <Figure
      id={ID}
      height={230}
      title="Luftskrue med firkantet tap øverst på radiatoren og en radiatornøgle, hvis firkantede hul føres ind over tappen. Til højre ses nøglens hul forfra."
      caption="Radiatornøglens firkantede hul passer ind over den firkantede tap på luftskruen øverst på radiatoren."
    >
      {/* Radiatorens øverste hjørne */}
      <path d="M8,60 H120 Q132,60 132,72 V206" fill="none" stroke={C.dark} strokeWidth={STROKE.outline} />

      {/* Luftskrue: prop, hals og firkantet tap */}
      <rect x="132" y="76" width="18" height="20" rx="2" fill={C.page} stroke={C.dark} strokeWidth={STROKE.outline} />
      <rect x="150" y="80" width="14" height="12" rx="1" fill={C.page} stroke={C.dark} strokeWidth={STROKE.secondary} />
      <rect x="164" y="81" width="10" height="10" fill={C.light} stroke={C.dark} strokeWidth={STROKE.outline} />

      {/* Nøglen føres ind over tappen */}
      <line x1="196" y1="86" x2="182" y2="86" stroke={C.grey} strokeWidth={STROKE.secondary} strokeDasharray="3 3" markerEnd={arrow(ID, 'dark')} />

      {/* Radiatornøgle: muffe med firkantet hul og vinge */}
      <rect x="200" y="75" width="40" height="22" rx="3" fill={C.page} stroke={C.dark} strokeWidth={STROKE.outline} />
      <rect x="200" y="81" width="10" height="10" fill="none" stroke={C.grey} strokeWidth={STROKE.secondary} strokeDasharray="2 2" />
      <rect x="240" y="44" width="12" height="84" rx="5" fill={C.page} stroke={C.dark} strokeWidth={STROKE.outline} />

      {/* Nøglens hul set forfra */}
      <circle cx="300" cy="168" r="24" fill={C.page} stroke={C.dark} strokeWidth={STROKE.outline} />
      <rect x="293" y="161" width="14" height="14" fill={C.light} stroke={C.dark} strokeWidth={STROKE.outline} />

      {/* Labels */}
      <Label x={66} y={140} anchor="middle" lines={['Radiator']} />
      <Label x={169} y={48} anchor="middle" lines={['Firkantet tap']} />
      <Leader points="169,54 169,79" />
      <Label x={136} y={124} lines={['Luftskrue']} />
      <Leader points="141,99 141,110" />
      <Label x={260} y={80} lines={['Radiatornøgle']} />
      <Label x={356} y={214} anchor="end" kind="note" lines={['Nøglens hul set forfra']} />
    </Figure>
  );
}
